<template>
  <div class="flex justify-center items-center h-screen w-screen" style="height: 100dvh;">
    <SignIn class="" :afterSignInUrl="afterSignInUrl" />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'

// Get the redirect parameter from the URL.
const route = useRoute()
const afterSignInUrl = route?.query?.redirect || '/app'

definePageMeta({
  layout: false,
})

</script>
